// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2z5AZ","footer":"styles_footer__TALjS","passCodeTooltip":"styles_passCodeTooltip__2_Ntl"};